$(".sticky-div-logo-left").css("display", "none");
$(window).scroll(function(){
 parallax();
})

function parallax(){
if ($(this).scrollTop() > 200) {
  		//  $(".sticky-div-logo-left").css("display", "block");
  		 $(".sticky-div-logo-left").css("transition-timing-function", "ease-out");
  		 $(".sticky_nav div.logo img").css("width", "100%");
  		//  $(".sticky-div-logo-right").css("display", "none");
		 $(".next-nav").css("margin-left", "-30px");
	}
  if ($(this).scrollTop() < 199) {
  console.log($(this).scrollTop());
    	 $(".next-nav").css("margin-left", "0px");
    	 $(".sticky_nav div.logo img").css("width", "0%");
		//  $(".sticky-div-logo-left").css("display", "none");
  		//  $(".sticky-div-logo-right").css("display", "block");   
  }
}